export default {
  setMainInfo: "FrontEnd/setMainInfo",
  setQuestionnaireData: "FrontEnd/setQuestionnaireData",
  sendEmail: "FrontEnd/sendResultEmail",

  getMainInfoList: "BackEnd/getMainInfoList",
  getMainInfoAndQuestionDataDetails:
    "BackEnd/getMainInfoAndQuestionDataDetails",
};
